import React from "react";

import AppModal from "../AppModal";
import { i18n } from "../../translate/i18n";

export function VariablesModal({
	open,
	handleClose,
	variables,
	bulkMessage,
	setBulkMessage,
}) {
	return (
		<AppModal
			open={open}
			onClose={handleClose}
			title={i18n.t("bulkMessaging.variablesModal.title")}
			maxWidth={480}
			footer={
				<button type="button" className="btn btn-sub-gray" onClick={handleClose}>
					{i18n.t("bulkMessaging.variablesModal.close")}
				</button>
			}
		>
			<p className="m-0 mb-3 text-sm text-default-500 dark:text-default-400">
				{i18n.t("bulkMessaging.variablesModal.hint")}
			</p>
			<div className="flex flex-wrap gap-2">
				{variables.map((variable) => (
					<button
						key={variable}
						type="button"
						className="rounded border border-default-200 bg-default-100 px-2.5 py-1 text-xs font-medium text-default-700 hover:border-primary hover:bg-primary/10 hover:text-primary dark:border-default-600 dark:bg-default-800 dark:text-default-200"
						onClick={() => {
							setBulkMessage({
								...bulkMessage,
								bulkMessagingData: {
									...bulkMessage.bulkMessagingData,
									message: bulkMessage.bulkMessagingData.message.concat(variable),
								},
							});
							handleClose();
						}}
					>
						{variable}
					</button>
				))}
			</div>
		</AppModal>
	);
}
